import { Divider, Form, Input, InputNumber, Radio, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { save, saveFlat } from "../../../../../features/save/saveSlice";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import BreadCrumb from "../../../../../layout/BreadCrumb";
import { fetchData } from "../../../../../features/fetch/fetchSlice";
import { formatText } from "../../../../../utils";
import CardLoading from "../../../../../components/CardLoading";

function ServicePerfAddForm() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { search } = useLocation();
  const queryParams1 = new URLSearchParams(search);
  const tab = queryParams1.get("tab");

  const url = "performance_metric/fetch_performancemetrics";
  const urlRadio = "performance_metric_radio/fetch_performancemetricradios";

  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);
  const perfType = queryParams.get("perfType");

  const { saving } = useSelector((state) => state.save);
  const { activeObjOrganized, activeObjSchemes, loading, data, dataRadio } =
    useSelector((state) => ({
      activeObjOrganized: state.obj.activeObj[perfType],
      activeObjSchemes: state.obj.activeObj["schemes"],
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      dataRadio: state.fetch.data[urlRadio] || [],
    }));

  const [radioOptionsMap, setRadioOptionsMap] = useState({});

  const handleCancel = () => {
    navigate(`/rob/scheme/indicators-list?tab=${tab}`);
  };

  const onFinish = async (values) => {
    const payload = Object.entries(values)?.map(([metrId, mvalValue]) => {
      const metric = Object.values(groupedMetrics)
        .flat()
        .find((m) => m?.metrId === metrId);
      const mvalId = metric?.mvalId || null;

      return {
        mvalMetrId: metrId,
        mvalValue,
        mvalSchId: activeObjSchemes?.schId,
        mvalId,
      };
    });
    const res = await dispatch(
      saveFlat({
        data: payload,
        url: `performance_metric_value/save_performancemetricvalue`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  async function fetchTableData() {
    await dispatch(
      fetchData({
        url: url,
        perfType: perfType,
        mvalSchId: activeObjOrganized?.mvalSchId,
        mvalCreatedTime:activeObjOrganized?.mvalCode,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    const fetchRadioOptions = async () => {
      const radioMetrics = data?.filter((m) => m?.metrUnit === "RADIO");
      for (const metric of radioMetrics) {
        try {
          const res = await dispatch(
            fetchData({
              url: urlRadio,
              metrdMetrId: metric.metrId,
              limit: null,
              start: 0,
            })
          );

          const options =
            res?.payload?.data?.map((opt) => ({
              label: opt?.metrdName,
              value: opt?.metrdName,
            })) || [];

          setRadioOptionsMap((prev) => ({
            ...prev,
            [metric?.metrId]: options,
          }));
        } catch (err) {
          console.error("Error fetching radio options:", err);
        }
      }
    };

    fetchRadioOptions();
  }, [data, url, dispatch]);
  useEffect(() => {
    fetchTableData();
  }, []);

  const initialFormValues = {};

  data?.forEach((metric) => {
    initialFormValues[metric?.metrId] = metric?.mvalValue;
  });
  useEffect(() => {
    const values = {};
    data?.forEach((m) => {
      values[m?.metrId] = m?.mvalValue;
    });
    form.setFieldsValue(values);
  }, [data]);

  const groupedMetrics = data?.reduce((groups, metric) => {
    const { metrType } = metric;
    if (!groups[metrType]) {
      groups[metrType] = [];
    }
    groups[metrType]?.push(metric);
    return groups;
  }, {});

  return (
    <div className="flex flex-col">
      <BreadCrumb
        breadcrumbs={[
          { title: "Schemes Overview", path: "/scheme/scheme-overview" },
          { title: "Public", path: "/scheme/public-scheme" },
          { title: "Public View", path: "/scheme/public-scheme-view" },
          {
            title: `Performance Indicators ${activeObjSchemes?.schName}`,
            path: `/rob/scheme/indicators-list?tab=${tab}`,
          },
          { title: `${formatText(perfType)} Add Form` },
        ]}
      />
      <div className="white_card mt-[1.25rem]">
        <div className="form-add-h mb-[1.5rem]">{formatText(perfType)}</div>
        <Divider />
        <div className="w-full  ">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className=""
            style={{
              maxWidth: "100%",
            }}
            form={form}
            initialValues={initialFormValues}
          >
            {Object?.keys(groupedMetrics)?.map((metrType) => (
              <div key={metrType}>
                <div className="custom-title mt-[3rem]">{metrType}</div>

                <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
                  {groupedMetrics[metrType]?.map((metric) => (
                    <Form.Item
                      key={metric?.metrId}
                      name={metric?.metrId}
                      label={metric?.metrLabel}
                      rules={[
                        {
                          required: metric?.metrRequired,
                          message: metric?.metrLabel + "Required",
                        },
                      ]}
                    >
                      {metric?.metrUnit === "NUMBER" ? (
                        <InputNumber
                          suffix={metric?.suffix}
                          min={0}
                          formatter={(value) =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }
                          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                          className="input flex"
                        />
                      ) : metric?.metrUnit === "RADIO" ? (
                        <Radio.Group
                          options={radioOptionsMap[metric?.metrId] || []}
                          className="flex lg:flex-row flex-col gap-y-[.5rem]"
                        />
                      ) : (
                        <Input suffix={metric?.suffix} className="input" />
                      )}
                    </Form.Item>
                  ))}
                </div>
              </div>
            ))}
            <div className="flex justify-between mt-[48px] ">
              <div className="justify-start"></div>
              <div className="justify-end flex items-center mb-[58px] gap-x-5">
                <div className="w-[150px]">
                  <button
                    type="button"
                    key="back"
                    onClick={handleCancel}
                    className="cstm-btn"
                  >
                    Cancel
                  </button>
                </div>

                <div className="w-[150px]">
                  <button
                    disabled={saving}
                    key="submit"
                    type="submit"
                    className="cstm-btn-2"
                  >
                    {saving ? (
                      <Spin />
                    ) : activeObjOrganized?.irrismId ? (
                      "Update"
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default ServicePerfAddForm;
